<template>
  <section>
    <transition mode="out-in">
      <form>
        <input
          type="text"
          name="name"
          id="name"
          v-model="name"
          placeholder="Name (i.e. contact, business or agency)"
        />

        <input
          type="text"
          name="location"
          id="location"
          v-model="location"
          placeholder="Location (i.e. address, city, state, zip, country)"
        />

        <select name="program" v-model="program">
          <option value disabled>CHI Program</option>
          <option :value="index" v-for="(p, index) in programs" :key="index">{{ p }}</option>
        </select>

        <select v-if="roles && roles.length" name="role" v-model="role" key="select">
          <option value disabled>Program Role</option>
          <option v-for="(r, index) in roles" :key="index">{{ r }}</option>
        </select>
        <PageLoading v-if="rolesLoading" key="rolesLoading" />

        <div>
          <label class="container">
            Show only active contacts
            <input
              v-model="isActive"
              name="active-only"
              id="active-only"
              type="checkbox"
              checked="checked"
            />
            <span class="checkmark"></span>
          </label>
        </div>

        <div class="btns">
          <input type="submit" value="Search" @click.prevent="searchEntries" />
          <input type="submit" value="Clear" id="clear" @click.prevent="clearFilters" />
        </div>
      </form>
    </transition>
  </section>
</template>

<script>
import { api } from "@/services.js";

export default {
  name: "DirectoryFilters",
  data() {
    return {
      name: "",
      location: "",
      programs: {
        AYP: "Academic Year",
        AP: "Au Pair",
        GHP: "Group Homestay",
        //ITP: "Internship & Training",
        STEP: "Short Term Enrichment",
        WT: "Work & Travel"
      },
      roles: null,
      program: "",
      role: "",
      isActive: true,
      rolesLoading: false
    };
  },
  methods: {
    searchEntries() {
      this.$router
        .push({
          query: {
            q: this.name,
            _page: 1,
            location: this.location,
            program: this.program,
            role: this.role,
            active: this.isActive
          }
        })
        .catch(err => {
          err;
        });
    },
    clearFilters() {
      this.name = "";
      this.location = "";
      this.program = "";
      this.roles = null;
      this.role = "";
      this.isActive = true;
      this.$router.push("/").catch(err => {
        err;
      });
    }
  },
  watch: {
    program() {
      if (this.program.length) {
        this.roles = null;
        this.role = "";
        this.rolesLoading = true;
        api.get(`/roles/${this.program}`).then(r => {
          if (r.data.length) {
            this.roles = r.data;
            this.rolesLoading = false;
          } else {
            this.roles = null;
            this.rolesLoading = false;
          }
        });
      }
    }
  },
  created() {
    this.$route.query.q ? (this.name = this.$route.query.q) : false;
    this.$route.query.location
      ? (this.location = this.$route.query.location)
      : false;
    this.$route.query.program
      ? (this.program = this.$route.query.program)
      : false;
    this.$route.query.active
      ? (this.isActive = this.$route.query.active)
      : true;
    this.$route.query.role ? (this.role = this.$route.query.role) : false;
  }
};
</script>

<style scoped>
form {
  max-width: 700px;
  margin: 30px auto;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}

form input[type="text"] {
  margin: 10px;
}

form select {
  margin: 10px;
}

form > div {
  margin: 10px;
}

.btns {
  display: flex;
  justify-content: center;
}

.btns input {
  display: block;
  margin: 20px 10px 0 10px;
  padding: 10px 30px;
  background: #9e1b32;
  border-radius: 4px;
  color: #fff;
  text-align: center;
  font-size: 1rem;
  box-shadow: 0 4px 8px rgba(30, 60, 90, 0.2);
  transition: all 0.3s;
  border: none;
  font-family: "Poppins", Helvetica, Arial, sans-serif;
  cursor: pointer;
}

.btns input:hover {
  background: #b80932;
  transform: scale(1.1);
}

select,
input[type="text"] {
  box-shadow: 0 4px 8px rgba(30, 60, 90, 0.1);
  padding: 20px;
  border: none;
  border-radius: 4px;
  transition: all 0.3s;
  color: #555;
}

select:hover,
select:focus,
input[type="text"]:focus,
input[type="text"]:hover {
  outline: none;
  transform: scale(1.02);
  box-shadow: 0 6px 12px rgba(30, 60, 90, 0.2);
}

select,
input[type="text"] {
  font-family: "Poppins", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 1rem;
}

/* The container */
.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 1rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #9e1b32;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

@media only screen and (max-width: 767px) {
  select,
  input[type="text"] {
    box-shadow: 0 2px 4px rgba(30, 60, 90, 0.1);
    padding: 15px 15px;
  }

  select:hover,
  select:focus,
  input[type="text"]:focus,
  input[type="text"]:hover {
    outline: none;
    transform: scale(1.01);
    box-shadow: 0 4px 8px rgba(30, 60, 90, 0.2);
  }

  select,
  input[type="text"] {
    font-family: "Poppins", Tahoma, Geneva, Verdana, sans-serif;
    font-size: 0.86rem;
    letter-spacing: -0.02rem;
  }

  .container {
    font-size: 0.86rem;
  }
  .checkmark {
    height: 22px;
    width: 22px;
  }
  .container .checkmark:after {
    left: 8px;
    top: 2px;
    width: 5px;
    height: 10px;
  }
}
</style>
